import { combineReducers } from 'redux';
import utils from '../../lib/utils';
import {
  defaultSimActivationState,
  SIM_ACTIVATION,
  defaultDataCenterState,
  eDataCenterStateAction,
} from './constants';

// destructuring utils
const { getUniqueAndReplaceWithNew } = utils;

const defaultBoxDetails = {};
const box = (state = defaultBoxDetails, action) => {
  switch (action.type) {
    case 'BOX_DETAILS_DATA':
    case 'EPIK_BOX_SUCCESS': {
      const box = action.box || {};
      if (state.swapInProgress && !box.swapInProgress) {
        return {
          ...box,
          swapInProgress: true,
          swapPartnerSerial: box.swapPartnerSerial || state.swapPartnerSerial,
          swapStartedAt: box.swapStartedAt || state.swapStartedAt,
        };
      }
      return box;
    }
    case 'UPDATE_FIELD_BOX': {
      const { name, value } = action;
      return { ...state, [name]: value };
    }
    case 'GET_ENGINEERING_LOCK_SUCCESS': {
      const { engineeringLock } = action;
      return { ...state, engineeringLock };
    }
    case 'UPDATE_BOX_ON_OBIS_UPDATE': {
      var { _id } = action.obis;
      return {
        ...state,
        Obis: state.Obis?.map(item => {
          if (item._id == _id) {
            return { ...action.obis };
          } else return { ...item };
        }),
      };
    }
    case 'OOB_UPDATE': {
      console.log('boxupdated  OOB_UPDATE', state.OBEnable)
      return { ...state, OBEnable: !state.OBEnable };
    }
    case 'HANDLE_ETH03':
      return { ...state, ...action.payload };
    case 'EPIK_BOX_SMART':
      return { boxId: action.box };
    case 'NETWORK_INFO_UPDATE':
      return { ...state, networkInterfaceInfo: action.payload };
    case 'SWAP_STATUS_UPDATE':
      return {
        ...state,
        swapInProgress: action.swapInProgress,
        swapPartnerSerial: action.swapPartnerSerial,
        swapStartedAt: action.swapStartedAt,
      };
    default:
      return state;
  }
};

const defaultSignalStrength = null;
const signalStrength = (state = defaultSignalStrength, action) => {
  switch (action.type) {
    case 'EPIK_BOX_SINGNAL_SUCCESS': {
      const { signal } = action;
      return signal;
    }
    case 'EPIK_BOX_SINGNAL_ERROR': {
      const { signal } = action;
      return signal;
    }
    default:
      return state;
  }
};

const defaultEngineeringLock = null;
const engineeringLock = (state = defaultEngineeringLock, action) => {
  switch (action.type) {
    case 'GET_ENGINEERING_LOCK_SUCCESS': {
      const { engineeringLock } = action;
      return engineeringLock;
    }
    default:
      return state;
  }
};
const defaultBoxLocations = {};
const boxLocations = (state = defaultBoxLocations, action) => {
  switch (action.type) {
    case 'GET_BOX_LOCATIONS_SUCCESS':
      return action.locations;
    default:
      return state;
  }
};

const defaultPortList = null;
const portForwardList = (state = defaultPortList, action) => {
  switch (action.type) {
    case 'GET_PORT_FORWARD_LIST_SUCCESS':
      return action.data;
    case 'ADD_PORT_FORWARD_SUCCESS':
      return action.data;
    case 'UPDATE_PORT_FORWARD_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

const defaultSystemStatus = [];
const systemStatus = (state = defaultSystemStatus, action) => {
  switch (action.type) {
    case 'SYSTEM_STATUS_SUCCESS':
      return action.systemStatus;
    default:
      return state;
  }
};
const defaultLatestRelease = {};
const latestRelease = (state = defaultLatestRelease, action) => {
  switch (action.type) {
    case 'LATEST_RELEASE_NOTE_SUCCESS':
      return action.data;
    default:
      return state;
  }
};
const defaultObiSystemStatus = [];
const obiSystemStatus = (state = defaultObiSystemStatus, action) => {
  switch (action.type) {
    case 'OBI_SYSTEM_STATUS_SUCCESS':
      return action.portObiSystemStatus;
    default:
      return state;
  }
};

// bulk box session reducer
const deafultBulkBoxSessions = [];
const bulkBoxSession = (state = deafultBulkBoxSessions, action) => {
  switch (action.type) {
    case 'BULK_BOX_SESSION': {
      const finalBulkActions = getUniqueAndReplaceWithNew([...state, action.payload], 'key');
      return finalBulkActions;
    }
    case 'BULK_BOX_SESSION_RESET':
      return deafultBulkBoxSessions;
    default:
      return state;
  }
};

const defaultAdvConfig = false;
const advModemConfigValue = (state = defaultAdvConfig, action) => {
  switch (action.type) {
    case 'ADV_MODEM_CONFIG': {
      return action.value || false;
    }
    default:
      return state;
  }
};

const callerIdOverride = '';
const callerIdOverrideValue = (state = callerIdOverride, action) => {
  switch (action.type) {
    case 'CALLER_ID_OVERRIDE': {
      return action.value || '';
    }
    default:
      return state;
  }
};

const defaultBlockCallerId = false;
const blockCallerIdConfigValue = (state = defaultBlockCallerId, action) => {
  switch (action.type) {
    case 'BLOCK_CALLER_ID': {
      return action.value || false;
    }
    default:
      return state;
  }
};

// All log sessions
const defaultGetSystemLogs = null;
const systemLogs = (state = defaultGetSystemLogs, action) => {
  switch (action.type) {
    case 'GET_ALL_LOGS':
      return action.payload;
    default:
      return state;
  }
};

// Dashboard monitoring
const defaultDashboardMonitoring = null;
const dashboardMonitoring = (state = defaultDashboardMonitoring, action) => {
  switch (action.type) {
    case 'GET_DASHBOARD_MONITORING_SUCCESS':
      return action;
    default:
      return state;
  }
};

// PRI state managemnet
const defaultPRIState = false;
const PRIStatus = (state = defaultPRIState, action) => {
  switch (action.type) {
    case 'PRI_INTIAL_STATE':
      return action.payload;
    default:
      return state;
  }
};

// SIP state managemnet
const defaultSIPState = false;
const SIPStatus = (state = defaultSIPState, action) => {
  switch (action.type) {
    case 'SIP_INTIAL_STATE':
      return action.payload;
    default:
      return state;
  }
};

const defaultSimCheck = [];
const simCheck = (state = defaultSimCheck, action) => {
  switch (action.type) {
    case 'UPDATE_SIM_CHECK_UTILITIES_SUCCESS':
      return action.data;
    case 'GET_SIM_CHECK_UTILITIES':
      return [];
    case 'BOX_DETAILS_DATA':
      return [];
    default:
      return state;
  }
};

const simActivationCheck = (state = defaultSimActivationState, action) => {
  switch (action.type) {
    case SIM_ACTIVATION.RESET:
      return defaultSimActivationState;

    case SIM_ACTIVATION.START_LOADING:
      return {
        connection: [],
        error: '',
        loading: true,
      };

    case SIM_ACTIVATION.LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SIM_ACTIVATION.UPDATE:
      return {
        error: '',
        loading: false,
        connection: action.payload,
      };

    case SIM_ACTIVATION.ERROR:
      return {
        connection: [],
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

const dataCenterLatency = (state = defaultDataCenterState, action) => {
  const { type } = action;
  switch (type) {
    case eDataCenterStateAction.UPDATE: {
      const { payload } = action;
      return {
        error: '',
        loading: false,
        data: payload,
      };
    }
    case eDataCenterStateAction.RESET_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }
    case eDataCenterStateAction.LOADING: {
      return {
        error: '',
        data: { ...defaultDataCenterState.data },
        loading: true,
      };
    }
    case eDataCenterStateAction.ERROR: {
      const { payload } = action;
      const { data } = state;
      if (data?.chPingAvg || data?.laPingAvg) {
        return { ...defaultDataCenterState };
      }
      return {
        ...state,
        loading: false,
        error: payload,
      };
    }
    case eDataCenterStateAction.RESET: {
      return {
        ...defaultDataCenterState,
      };
    }
    default:
      return state;
  }
};

const boxActivityCheck = null;
const boxCdrActivity = (state = boxActivityCheck, action) => {
  switch (action.type) {
    case 'GET_VOIPMON_ACTIVITY_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

const maintenanceNotify = [];
const maintenanceNotification = (state = maintenanceNotify, action) => {
  switch (action.type) {
    case 'SET_MAINTENANCE_NOTE_SEEN_SUCCESS':
      return action.data;
    default:
      return state;
  }
};

const oobsInitialState = [];
const oobList = (state = oobsInitialState, action) => {
  switch (action.type) {
    case 'OOB_SUCCESS':
      return { ...state, ...action.data }
    default:
      return state;
  }
};

const defaultTtyData = null;
const oobmTtyData = (state = defaultTtyData, action) => {
  switch (action.type) {
    case 'TTY_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

const systemTabLogs = [];
const getSystemLogsSuccess = (state = systemTabLogs, action) => {
  switch (action.type) {
    case 'SYSTEM_LOGS_SUCCESS':
      return { ...state, ...action.data }
    default:
      return state;
  }
};

const oobBtnsInitialState = [];
const oobOrderedBtns = (state = oobBtnsInitialState, action) => {
  switch (action.type) {
    case 'OOB_ORDER_BTN_SUCCESS':
      return action.data
    default:
      return state;
  }
};

const defaultDeviceSwapResult = { open: false, result: null };
const deviceSwapResult = (state = defaultDeviceSwapResult, action) => {
  switch (action.type) {
    case 'DEVICE_SWAP_RESULT':
      return { open: true, result: action.result || null };
    case 'DEVICE_SWAP_RESULT_CLOSE':
      return { open: false, result: null };
    default:
      return state;
  }
};

export default combineReducers({
  box,
  deviceSwapResult,
  engineeringLock,
  boxLocations,
  systemStatus,
  obiSystemStatus,
  latestRelease,
  bulkBoxSession,
  portForwardList,
  systemLogs,
  dashboardMonitoring,
  PRIStatus,
  SIPStatus,
  simCheck,
  simActivationCheck,
  dataCenterLatency,
  boxCdrActivity,
  advModemConfigValue,
  signalStrength,
  callerIdOverrideValue,
  maintenanceNotification,
  oobList,
  blockCallerIdConfigValue,
  getSystemLogsSuccess,
  oobmTtyData,
  oobOrderedBtns
});
